// extracted by mini-css-extract-plugin
export var button = "add-recipe-to-plan-modal-module--button--N6lvd";
export var form = "add-recipe-to-plan-modal-module--form--UYJz6";
export var grid = "add-recipe-to-plan-modal-module--grid--KyNcu";
export var loader = "add-recipe-to-plan-modal-module--loader--4nbCd";
export var modal = "add-recipe-to-plan-modal-module--modal--LkWYT";